module.exports = __webpack_public_path__ + "static/img/cocina_03.6dca3e08.jpeg";